import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import "ngmap";

import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";

class EventliveController {
  constructor($http, $localStorage, $state, AuthService, EventsService, SecurityService, $stateParams, $timeout, NgMap, $rootScope, $scope) {
    this.name = "eventlive";
    $localStorage.activeStateName = "events";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.remain_loading_count = 0;
    this.acceptedApplicants = [];
    this.pagesAccepted = [];
    this.checkedInArray = [];
    this.checkedOutArray = [];
    this.queryLimitCounter = 0;
    this.zoom = 7;
    this.applications = [];
    this.liveObj = {};
    this.$maps = NgMap;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.mapHasLoaded = false;
    var _this = this;

    _this.remain_loading_count++;

    _this.$timeout(function () {
      _this.mapHasLoaded = true;
    }, 3000);

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 3, total: 2});
    });

    _this.remain_loading_count++;

    this.$events.getEventByIdTrimmedLive(this.$stateParams.eventId).then(
      function (data) {
        var response = data.data;

        _this.event = response;

        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventSidebar", {
            event: _this.event,
          });
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 9,
            total: 2,
          });
        });

        console.log(_this.event);
        if (_this.event.status === "error") {
          _this.remain_loading_count--;
          return;
        }

        _this.$rootScope.$emit("SetEventToEventDialog", {
          event: _this.event,
        });
        _this.currentSubEvent = response.subEvents[0];

        var pageArrayAccepted = [];
        var numberOfApprovedApplications = Math.ceil(response.numberOfApprovedApplications / 5);

        for (var i = 0; i < numberOfApprovedApplications; i++) {
          pageArrayAccepted.push(i + 1);
          _this.pagesAccepted = pageArrayAccepted;
        }

        var city = response.contactInfo.city;
        var street = response.contactInfo.streetLine1;
        var state = response.contactInfo.state;
        var zipCode = response.contactInfo.zipCode;
        var address = street + ", " + city + ", " + state;
        var startTimeMomentJsObj = moment(response.startTime).format();
        var endTimeMomentJsObj = moment(response.endTime).format();

        _this.event = response;

        if (response.subEvents[0].deduppedJobbles[0].shifts) {
          _this.liveObj = _this.$security.isThisEventLive(response.subEvents[0].deduppedJobbles[0].shifts);
        } else {
          _this.liveObj.eventIsLive = false;
        }

        console.log("_this.liveObj");
        console.dir(_this.liveObj);

        if (_this.liveObj.eventIsLive === true) {
          _this.eventIsLive = true;
          _this.displayLiveLoader = false;
        } else {
          _this.eventIsLive = false;
        }

        _this.$timeout(function () {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({address: address}, function (results, status) {
            console.log("geocoder");
            console.dir(results);
            console.dir(status);
            if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
              var location = results[0].geometry.location;
              _this.centerLat = location.lat();
              _this.centerLng = location.lng();
              var myLatLngEv = {
                lat: location.lat(),
                lng: location.lng(),
              };
              var image = "/app/vendor/images/icon-location.png";
              var marker = new google.maps.Marker({
                title: _this.event.name,
                icon: image,
                position: myLatLngEv,
              });
              _this.setCenterOfMap(marker);
              _this.getApplicantsOnMap(0);
            } else {
              _this.remain_loading_count--;
            }
          });
        }, 2000);
      },
      function (data) {
        console.log(data);
        _this.remain_loading_count--;
        $state.go("events");
      }
    );

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      if (_this.event.id === params.event.id) {
        _this.event.cost = params.event.cost;
        _this.event.numberOfOpenings = params.event.numberOfOpenings;
        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
      }
    });

    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
      _this.$state.go("jobsdashboard");
    });

    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);

    $timeout(function () {
      $("eventsidebar .jobs-complete-sidebar li:nth-child(6)").removeClass().addClass("active");
    }, 2000);
  }

  setCenterOfMap(marker) {
    var _this = this;

    _this.$timeout(function () {
      _this.$maps.getMap({id: "mapId"}).then(
        function (map) {
          //console.log('success find map-------------------------------------------');
          //console.dir(map);
          _this.map = map;
          _this.zoom = 12;
          _this.remain_loading_count = 0;
          marker.setMap(_this.map);
        },
        function (data) {
          _this.remain_loading_count = 0;
          //console.log('error');
          //console.dir(data);
        }
      );
    }, 1000);
  }

  getApplicantsOnMap(offset) {
    var _this = this;
    this.applications = [];
    var applicationsReadyForLocationLoop = [];
    if (offset !== 0) {
      offset = offset * 5 - 5;
    }
    var _this = this;
    console.log("getApplicantsOnMap");
    this.$events.getAcceptedApplicationsTrimmedLive(this.event.subEvents[0].id, _this.event.totalNumberOfApplications).then(
      function (applications) {
        var numberOfApps = applications.data.length;
        var apps = applications.data;
        _this.totalApplicationsCount = apps.length;
        if (_this.liveObj.eventIsLive === true) {
          if (apps.length !== 0) {
            try {
              apps.forEach(function (application, index) {
                var checkInAndOutObj = _this.$security.isThisEventLive(application.jobble.shifts);
                application.locationInfo = checkInAndOutObj;
                applicationsReadyForLocationLoop.push(application);
                if (application.locationInfo.checkInLat) {
                  _this.setJobblersToTheMap(application);
                }
              });
            } finally {
              _this.geocoderPerApp = new google.maps.Geocoder();
              _this.getCheckInLocationData(applicationsReadyForLocationLoop);
            }
          } else {
            _this.applications = apps;
          }
        } else {
        }
      },
      function (data) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setJobblersToTheMap(application) {
    var _this = this;

    console.log("setJobblersToTheMap");
    console.dir(application);

    var jobblerName = application.applicant.firstName + " " + application.applicant.lastName;
    var image = "/app/vendor/images/icon-location-jobbler.png";
    var myLatLng = {
      lat: application.locationInfo.checkInLat,
      lng: application.locationInfo.checkInLng,
    };

    var marker = new google.maps.Marker({
      title: jobblerName,
      icon: image,
      position: myLatLng,
    });
    marker.setMap(_this.map);
  }

  getCheckInLocationData(applications) {
    var _this = this;

    applications.forEach(function (application, i) {
      if (application.locationInfo.checkInLat !== null) {
        (function (application) {
          _this.$timeout(function () {
            _this.checkedInArray.push(application);

            var myLatLng = {
              lat: application.locationInfo.checkInLat,
              lng: application.locationInfo.checkInLng,
            };

            _this.geocoderPerApp.geocode({latLng: myLatLng}, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                  application.locationInfo.checkInAddress = results[0].formatted_address;
                } else {
                  application.locationInfo.checkInAddress = "Address not captured";
                }
              } else {
                application.locationInfo.checkInAddress = "Address not captured";
              }
            });
          }, i * 1000);
        })(application);
      }
    });

    /*
	  _this.$timeout(function(){
		  _this.applications = applications;
	  })
	  */

    this.$timeout(function () {
      _this.getCheckOutLocationData(applications);
    }, 2000);
  }

  getCheckOutLocationData(applications) {
    var _this = this;

    applications.forEach(function (application, i) {
      if (application.locationInfo.checkOutTime !== null) {
        _this.checkedOutArray.push(application);

        _this.$timeout(function () {
          var geocoderPerAppCheckout = new google.maps.Geocoder();
          var myLatLngCheckout = {
            lat: application.locationInfo.checkOutLat,
            lng: application.locationInfo.checkOutLng,
          };

          console.log("check it here********************************************");
          console.dir(myLatLngCheckout);

          if (myLatLngCheckout.lat !== null && myLatLngCheckout.lng !== null) {
            geocoderPerAppCheckout.geocode({latLng: myLatLngCheckout}, function (results, status) {
              console.log("------------------");
              console.log("------------------");
              console.log("------------------");

              console.dir(application);
              console.dir(results);
              console.dir(status);

              if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                  application.locationInfo.checkOutAddress = results[0].formatted_address;
                } else {
                  application.locationInfo.checkOutAddress = "Address not recognized by google";
                }
              } else {
                application.locationInfo.checkOutAddress = "Address not recognized by google";
              }
            });
          } else {
            console.log("check out it null");
          }
        }, i * 2000);
      }
    });

    this.$timeout(function () {
      _this.applications = applications;

      console.log("HOW MUCH LONGER TIL THIS GETS LOADED?");
    }, 1000);

    this.$timeout(function () {
      _this.applications = applications;
    }, 5000);
  }
}

EventliveController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "security",
  "$stateParams",
  "$timeout",
  "NgMap",
  "$rootScope",
  "$scope",
];

export default EventliveController;



// WEBPACK FOOTER //
// ./client/app/components/eventlive/eventlive.controller.js